module.exports = __webpack_public_path__ + "img/45-r.bb76856c.png";